export default "<ul>\n  <li hidden>공유</li>\n  <li tappable (click)=\"editfoldername(folder, folderInput)\">폴더명 변경</li>\n</ul>";